// extracted by mini-css-extract-plugin
export default {"section":"ProjectDocuments_section__1yUBF","mobile":"ProjectDocuments_mobile__zy40D","sectionTitle":"ProjectDocuments_sectionTitle__pSF2j","item":"ProjectDocuments_item__nYzEB"};